var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstandBet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--gray-40)",
    viewBox: "0 0 64 64",
    className: "svg-icon",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.986 0v23.28H52.12L31.986 64V37.814H11.88L31.986 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstandBet);
export default __webpack_public_path__ + "static/media/instand-bet.658953513fbb6fa4a74d73c1bca190ae.svg";
export { ForwardRef as ReactComponent };